<template>
  <div class="screen-container bg-[#0f172a] min-h-screen text-white overflow-hidden font-sans select-none">
    
    <div v-if="!tokenProvided" class="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/90 backdrop-blur-xl">
      <div class="bg-slate-900 p-10 rounded-[3rem] border border-slate-700 shadow-2xl max-w-md w-full text-center">
        <div class="w-20 h-20 bg-blue-600 rounded-3xl flex items-center justify-center mx-auto mb-6 shadow-lg shadow-blue-500/20">
          <svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
        </div>
        <h2 class="text-2xl font-black mb-2 uppercase tracking-tight">Configuration Écran</h2>
        <p class="text-slate-400 text-sm mb-8 font-medium">Veuillez saisir le token de couplage</p>
        <input v-model="inputToken" type="password" placeholder="Token..." 
               class="w-full bg-slate-800 border-2 border-slate-700 rounded-2xl px-6 py-4 mb-4 focus:border-blue-500 outline-none transition-all text-center font-mono tracking-widest text-xl">
        <button @click="saveToken" class="w-full bg-blue-600 hover:bg-blue-500 text-white font-black py-4 rounded-2xl transition-all shadow-lg shadow-blue-600/20 active:scale-95">
          ACTIVER L'ÉCRAN
        </button>
      </div>
    </div>

    <template v-else>
      <header class="h-[100px] px-10 bg-slate-900/50 flex justify-between items-center border-b border-slate-800 backdrop-blur-md relative z-10">
        <div class="flex items-center gap-6">
          <h1 class="text-4xl font-black tracking-tighter uppercase">{{ agencyName || 'Chargement...' }}</h1>
          
          <button v-if="!audioEnabled" @click="enableAudio" 
                  class="ml-4 px-4 py-2 bg-yellow-500/20 border border-yellow-500/50 text-yellow-500 rounded-xl text-xs font-black animate-pulse flex items-center gap-2">
            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM14.657 2.929a1 1 0 011.414 0A9.972 9.972 0 0119 10a9.972 9.972 0 01-2.929 7.071 1 1 0 01-1.414-1.414A7.971 7.971 0 0017 10c0-2.21-.894-4.208-2.343-5.657a1 1 0 010-1.414zm-2.829 2.828a1 1 0 011.415 0A5.983 5.983 0 0115 10a5.983 5.983 0 01-1.757 4.243 1 1 0 01-1.415-1.415A3.984 3.984 0 0013 10a3.984 3.984 0 00-1.172-2.828 1 1 0 010-1.415z"/></svg>
            ACTIVER LE SON
          </button>
          <div v-else class="ml-4 flex items-center gap-2 text-green-500 text-[10px] font-black uppercase opacity-50">
            <span class="w-2 h-2 bg-green-500 rounded-full"></span> Audio prêt
          </div>
        </div>


        <div class="flex flex-col items-end gap-2">
  <div class="text-right">
    <span class="text-[10px] font-black text-blue-500 uppercase tracking-[0.3em] mb-1 block">Heure locale</span>
    <div class="text-5xl font-mono font-black text-white tabular-nums leading-none">{{ currentTime }}</div>
  </div>
  
  <button @click="resetToken" 
          class="text-[9px] font-bold text-slate-500 hover:text-red-400 uppercase tracking-widest transition-colors flex items-center gap-1">
    <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
    </svg>
    Déconnecter l'écran
  </button>
</div>
      </header>

      <main class="grid grid-cols-12 h-[calc(100vh-180px)]">
        <div class="col-span-8 flex flex-col items-center justify-center p-12 relative overflow-hidden">
          <transition name="flash">
            <div v-if="isAnimating" class="absolute inset-0 bg-blue-600/15 z-0"></div>
          </transition>

          <div v-if="callingTicket" class="relative z-10 text-center">
            <transition name="pop" mode="out-in">
              <div :key="callingTicket.number">
                <span class="text-4xl font-black uppercase tracking-[0.5em] text-blue-500 mb-6 block animate-pulse">CLIENT APPELÉ</span>
                <div class="text-[22rem] font-black leading-none mb-10 text-white drop-shadow-[0_20px_20px_rgba(0,0,0,0.5)]">
                  {{ callingTicket.number }}
                </div>
                <div class="px-16 py-8 bg-blue-600 rounded-[3rem] text-6xl font-black uppercase shadow-2xl border-4 border-blue-400/30">
                  {{ callingTicket.counterName }}
                </div>
              </div>
            </transition>
          </div>
          
          <div v-else class="text-slate-600 text-4xl font-black uppercase tracking-widest opacity-30 animate-pulse">
            En attente d'appel
          </div>
        </div>

        <div class="col-span-4 bg-black/20 backdrop-blur-sm border-l border-slate-800 p-8">
          <h2 class="text-xl font-black uppercase tracking-widest text-slate-500 mb-8 flex items-center gap-4">
            <span class="h-px bg-slate-800 flex-1"></span> HISTORIQUE <span class="h-px bg-slate-800 flex-1"></span>
          </h2>
          <div class="space-y-4">
            <transition-group name="list">
              <div v-for="ticket in lastTickets" :key="ticket._id" 
                   class="flex justify-between items-center p-6 bg-slate-800/40 rounded-[2rem] border border-slate-700/50">
                <div class="flex flex-col">
                  <div class="text-5xl font-black text-white mb-1">{{ ticket.number }}</div>
                  <div class="text-xs font-black text-blue-500 uppercase tracking-widest">{{ ticket.queueId?.name || 'Service' }}</div>
                </div>
                <div class="px-6 py-3 bg-slate-700/50 rounded-2xl text-xl font-black text-slate-300">
                  {{ ticket.counterName }}
                </div>
              </div>
            </transition-group>
          </div>
        </div>
      </main>

      <footer class="h-[80px] bg-slate-950 border-t border-slate-800 flex items-center px-10 overflow-hidden">
        <div class="flex gap-12 animate-scroll whitespace-nowrap">
          <div v-for="queue in queueStats" :key="queue.name" class="flex items-center gap-4">
            <span class="w-3 h-3 bg-green-500 rounded-full"></span>
            <span class="text-sm font-black uppercase tracking-widest text-slate-400">{{ queue.name }}:</span>
            <span class="text-2xl font-black text-white">{{ queue.count }}</span>
          </div>
        </div>
      </footer>
    </template>

    <audio ref="bellSound" preload="auto">
  <source src="https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3" type="audio/mpeg">
</audio>
  </div>
</template>

<script>
import { io } from "socket.io-client";

export default {
  data() {
    return {
      socket: null,
      agencyName: "",
      callingTicket: null,
      lastTickets: [],
      queueStats: [],
      currentTime: "",
      isAnimating: false,
      inputToken: "",
      tokenProvided: false,
      audioEnabled: false 
    };
  },
  methods: {
    checkToken() {
      console.log("[Screen] 🔍 Vérification du token au démarrage...");
      const urlParams = new URLSearchParams(window.location.search);
      const urlToken = urlParams.get("token");
      const localToken = localStorage.getItem("deviceToken");
      
      const tokenToUse = urlToken || localToken;

      if (tokenToUse) {
        console.log("[Screen] ✅ Token trouvé :", tokenToUse === urlToken ? "via URL" : "via LocalStorage");
        this.tokenProvided = true;
        this.initSocket(tokenToUse);
      } else {
        console.warn("[Screen] ⚠️ Aucun token trouvé, affichage de l'écran de configuration.");
      }
    },

    enableAudio() {
      console.log("[Audio] 🔊 Tentative de déblocage de l'audio...");
      const bell = this.$refs.bellSound;
      if (bell) {
        bell.play().then(() => {
          bell.pause();
          bell.currentTime = 0;
          this.audioEnabled = true;
          console.log("[Audio] ✅ Système audio débloqué avec succès.");
        }).catch(e => {
          console.error("[Audio] ❌ Échec du déblocage audio automatique :", e.message);
        });
      }
    },
    resetToken() {
    if (confirm("Voulez-vous vraiment déconnecter cet écran ?")) {
      console.log("[Screen] 🗑️ Suppression du token et déconnexion...");
      
      // 1. Déconnexion propre du socket
      if (this.socket) {
        this.socket.disconnect();
      }

      // 2. Nettoyage du localStorage
      localStorage.removeItem("deviceToken");

      // 3. Réinitialisation de l'état local
      this.tokenProvided = false;
      this.agencyName = "";
      this.lastTickets = [];
      this.callingTicket = null;

      // 4. Optionnel : Nettoyer l'URL si le token y était présent
      const url = new URL(window.location);
      url.searchParams.delete('token');
      window.history.replaceState({}, document.title, url.pathname);
      
      // Force le rechargement pour repartir à zéro
      window.location.reload();
    }
  },

    saveToken() {
      console.log("[Config] 💾 Enregistrement du nouveau token...");
      if (this.inputToken.trim()) {
        this.enableAudio(); 
        localStorage.setItem("deviceToken", this.inputToken.trim());
        this.tokenProvided = true;
        this.initSocket(this.inputToken.trim());
      } else {
        console.error("[Config] ❌ Le champ token est vide.");
      }
    },

    updateClock() {
      const now = new Date();
      this.currentTime = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    },
    
    initSocket(deviceToken) {
      console.log("[Socket] 🌐 Initialisation de la connexion vers https://api.datafuse.fr ...");

      if (!deviceToken) {
        console.error("[Socket] ❌ Token Device manquant");
        return;
      }

      this.socket = io("https://api.datafuse.fr", {
        query: { token: deviceToken },
        transports: ['websocket', 'polling'],
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionAttempts: 5
      });

      this.socket.on("connect", () => {
        console.log("[Socket] ⚡ Connecté au serveur ! ID:", this.socket.id);
      });

      this.socket.on("connect_error", (err) => {
        console.error("[Socket] ❌ Erreur de connexion :", err.message);
      });

      this.socket.on("screen_init", (data) => {
        console.log("[Socket] 📥 Données initiales reçues :", data);
        this.agencyName = data.agencyName;
        this.lastTickets = data.tickets;
        this.updateQueueStats(data.tickets);
      });

      this.socket.on("ticket_called", (data) => {
        console.log("[Socket] 🔔 Nouveau ticket appelé :", data);
        this.handleNewCall(data);
      });

      this.socket.on("queue_updated", () => {
        console.log("[Socket] 🔄 Mise à jour de la file détectée...");
        this.refreshStats();
      });
      
      this.socket.on("disconnect", (reason) => {
        console.warn("[Socket] 🔌 Déconnecté. Raison :", reason);
      });
    },

    async refreshStats() {
      console.log("[API] 📡 Récupération des statistiques des files...");
      try {
        const deviceToken = localStorage.getItem("deviceToken") || new URLSearchParams(window.location.search).get("token");
        const res = await fetch("https://api.datafuse.fr/api/agency/queues", {
          headers: { "Authorization": `Bearer ${deviceToken}` }
        });
        const data = await res.json();
        if (res.ok && data.queue) {
          console.log("[API] ✅ Stats reçues :", data.queue.length, "tickets trouvés.");
          this.updateQueueStats(data.queue);
        } else {
          console.error("[API] ❌ Erreur lors du fetch stats :", data.message);
        }
      } catch (err) {
        console.error("[API] ❌ Erreur réseau lors du refreshStats :", err);
      }
    },

    handleNewCall(data) {
      const ticket = data.ticket || data;
      const counter = data.counterName || "Guichet";
      console.log(`[Display] 📢 Affichage du ticket ${ticket.number} au ${counter}`);

      // Logique Audio
      const bell = this.$refs.bellSound;
      if (bell) { 
        bell.currentTime = 0; 
        bell.play()
          .then(() => console.log("[Audio] 🎵 Son joué."))
          .catch(e => {
            console.warn("[Audio] 🔇 Lecture bloquée par le navigateur.");
            console.error(e);
            this.audioEnabled = false;
          }); 
      }

      // Synthèse vocale de secours
      if (!this.audioEnabled && 'speechSynthesis' in window) {
        console.log("[Audio] 🗣️ Tentative de synthèse vocale...");
        const msg = new SpeechSynthesisUtterance(`Ticket ${ticket.number} au ${counter}`);
        msg.lang = 'fr-FR';
        window.speechSynthesis.speak(msg);
      }

      this.callingTicket = { number: ticket.number, counterName: counter };
      this.isAnimating = true;
      
      // Nettoyage de l'animation
      setTimeout(() => { 
        this.isAnimating = false; 
        console.log("[Display] ✨ Animation terminée.");
      }, 4000);

      // Mise à jour historique local
      this.lastTickets = [ 
        { ...ticket, counterName: counter }, 
        ...this.lastTickets.filter(t => t._id !== ticket._id) 
      ].slice(0, 5);
    },

    updateQueueStats(tickets) {
        console.log("[Logic] 📊 Recalcul des compteurs par file d'attente...");
        const counts = {};
        tickets.forEach(t => {
            if(t.status === 'WAITING') {
                const name = t.queueId?.name || 'Général';
                counts[name] = (counts[name] || 0) + 1;
            }
        });
        this.queueStats = Object.keys(counts).map(name => ({ name, count: counts[name] }));
        console.log("[Logic] 📊 Nouveaux compteurs :", this.queueStats);
    }
  },
  mounted() {
    console.log("[Screen] 🚀 Composant monté.");
    this.updateClock();
    setInterval(this.updateClock, 1000);
    this.checkToken();
  }
};
</script>

<style scoped>
.list-enter-active, .list-leave-active { transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1); }
.list-enter-from { opacity: 0; transform: translateY(-20px); }

.pop-enter-active { animation: pop-in 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275); }
@keyframes pop-in {
  0% { transform: scale(0.5) translateY(50px); opacity: 0; }
  100% { transform: scale(1) translateY(0); opacity: 1; }
}

.flash-enter-active { animation: flash-bg 1s infinite; }
@keyframes flash-bg {
  0%, 100% { opacity: 0.1; }
  50% { opacity: 0.4; }
}

.animate-scroll {
  display: flex;
  animation: scroll 30s linear infinite;
}
@keyframes scroll {
  0% { transform: translateX(100vw); }
  100% { transform: translateX(-100%); }
}

::-webkit-scrollbar { display: none; }
</style>